import React from "react";
import {
  Dialog,
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

function CatchDialog(props) {
  const { combined_sales, handleClose } = props;
  return (
    <Dialog open={true}>
      <Box m={2} align="center">
        <h2 className="sectionTitle center">
          Can not submit Report!
          <Button
            style={{ marginRight: "10px", marginLeft: "10px" }}
            onClick={(e) => handleClose(e)}
          >
            Done
          </Button>
        </h2>
        <div>
          There are catch items that have not been accounted for. Please make
          the appropriate changes for catch kept, catch sales or disposition
          information.
        </div>
        <List>
          {combined_sales.map(function (d, idx) {
            return (
              <ListItem key={idx}>
                <ListItemText>
                  {`Species Code: ${d.species}`}
                  <br />
                  {`Species Name: ${d.species_label}`}
                  <br />
                  {`Qty. Available: ${d.available}`}
                  <br />
                  {`Accounted for: ${d.sold}`}
                  <br />
                </ListItemText>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Dialog>
  );
}

export default CatchDialog;
